export const FETCH_AUDIT_TRAIL_FAILURE = 'FETCH_AUDIT_TRAIL_FAILURE';
export const FETCH_AUDIT_TRAIL_START = 'FETCH_AUDIT_TRAIL_START';
export const FETCH_AUDIT_TRAIL_SUCCESS = 'FETCH_AUDIT_TRAIL_SUCCESS';
